import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { User } from '../api-generated';
import { LocalStorageService } from '../app/local-storage.service';
import { AuthService } from '../auth/auth.service';
import { NotificationService } from '../notification/notification.service';



@Injectable({
  providedIn: 'root'
})
export class HomeRouteGuardService  {

  constructor(
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private notificationService: NotificationService,
    private router: Router,
  ) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authService.getSessionUser(true)
    .pipe(
      map((user: User) => {
        // Zitadel ignores the logout return URL and lands every later sign-in on
        // home, so a reader who logged out of a dashboard is sent back to it from
        // here - once, and only if the same person signed back in.
        const dashboardReturn = user ? this.localStorageService.getDashboardLogoutReturn() : undefined;
        if (dashboardReturn) {
          this.localStorageService.setDashboardLogoutReturn(null);
          if (dashboardReturn.userIdentifier === user.identifier) return this.router.parseUrl(dashboardReturn.url);
        }

        if (user && route.url[0].path !== 'home-user') {
          return this.router.createUrlTree(['/home-user'], { queryParams: route.queryParams });
        } else if (!user && route.url[0].path === 'home-user') {
          return this.router.createUrlTree(['/home'], { queryParams: route.queryParams });
        } else {
          return true;
        }
      }),
    );
  }
}
